module.exports = __webpack_public_path__ + "static/media/fileUploadBlack.d3a98552.svg";